export default __webpack_public_path__ + "static/media/Case_Steel_Black.4492123f.png";